import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "linear-background card",
  style: {"min-height":"100%"}
}
const _hoisted_2 = { class: "d-flex flex-stack" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "m-0 text-white fw-bolder fs-3" }, "Auctions Summary", -1)
const _hoisted_4 = { class: "ms-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "d-flex text-center flex-column text-white pt-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-7" }, "Number Of Auctions", -1)
const _hoisted_8 = { class: "fw-bolder fs-2x pt-1" }
const _hoisted_9 = { class: "d-flex text-center flex-column text-white pt-8" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-7" }, "Number Of Auctions Properties", -1)
const _hoisted_11 = { class: "fw-bolder fs-2x pt-1" }
const _hoisted_12 = { class: "card-body p-0 d-flex flex-column" }
const _hoisted_13 = { class: "card-px pt-5 pb-10 flex-grow-1" }
const _hoisted_14 = { class: "row g-0 mt-5 mb-10" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "d-flex align-items-center me-2" }
const _hoisted_17 = { class: "symbol symbol-50px me-3" }
const _hoisted_18 = { class: "symbol-label bg-light-info" }
const _hoisted_19 = { class: "svg-icon svg-icon-1 svg-icon-info" }
const _hoisted_20 = { class: "fs-4 text-dark fw-bolder" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted fw-bold" }, "Upcoming Events", -1)
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "d-flex align-items-center me-2" }
const _hoisted_24 = { class: "symbol symbol-50px me-3" }
const _hoisted_25 = { class: "symbol-label bg-light-success" }
const _hoisted_26 = { class: "svg-icon svg-icon-1 svg-icon-success" }
const _hoisted_27 = { class: "fs-4 text-dark fw-bolder" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted fw-bold" }, "Upcoming Properties", -1)
const _hoisted_29 = { class: "row g-0 mt-5 mb-10" }
const _hoisted_30 = { class: "row g-0" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "d-flex align-items-center me-2" }
const _hoisted_33 = { class: "symbol symbol-50px me-3" }
const _hoisted_34 = { class: "symbol-label bg-light-primary" }
const _hoisted_35 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_36 = { class: "fs-4 text-dark fw-bolder" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted fw-bold" }, "Ongoing Events", -1)
const _hoisted_38 = { class: "col" }
const _hoisted_39 = { class: "d-flex align-items-center me-2" }
const _hoisted_40 = { class: "symbol symbol-50px me-3" }
const _hoisted_41 = { class: "symbol-label bg-light-warning" }
const _hoisted_42 = { class: "svg-icon svg-icon-1 svg-icon-warning" }
const _hoisted_43 = { class: "fs-4 text-dark fw-bolder" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted fw-bold" }, "Ongoing Properties", -1)
const _hoisted_45 = { class: "row g-0" }
const _hoisted_46 = { class: "col" }
const _hoisted_47 = { class: "d-flex align-items-center me-2" }
const _hoisted_48 = { class: "symbol symbol-50px me-3" }
const _hoisted_49 = { class: "symbol-label bg-light-danger" }
const _hoisted_50 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_51 = { class: "fs-4 text-dark fw-bolder" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted fw-bold" }, "Historical Events", -1)
const _hoisted_53 = { class: "col" }
const _hoisted_54 = { class: "d-flex align-items-center me-2" }
const _hoisted_55 = { class: "symbol symbol-50px me-3" }
const _hoisted_56 = { class: "symbol-label bg-light-dark" }
const _hoisted_57 = { class: "svg-icon svg-icon-1 svg-icon-dark" }
const _hoisted_58 = { class: "fs-4 text-dark fw-bolder" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-muted fw-bold" }, "Historical Properties", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_AdsFilterWidgets = _resolveComponent("AdsFilterWidgets")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([_ctx.widgetClasses, "card"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([`bg-${_ctx.color}`, "px-9 pt-7 card-rounded h-275px w-100"])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass([`btn-active-color-${_ctx.color}`, "btn btn-sm btn-icon btn-color-white btn-active-white border-0 me-n3"]),
                  "data-kt-menu-trigger": "click",
                  "data-kt-menu-placement": "bottom-end",
                  "data-kt-menu-flip": "top-end"
                }, [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
                  ])
                ], 2),
                _createVNode(_component_AdsFilterWidgets, {
                  onFilterSelected: _ctx.onTypeChange,
                  onReset: _ctx.onReset
                }, null, 8, ["onFilterSelected", "onReset"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.data.data.total), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.data.data.totalProperties), 1)
            ])
          ], 2),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen012.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.data.data.upcomingEventsCount), 1),
                      _hoisted_21
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen012.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.data.data.upcomingPropertiesCount), 1),
                      _hoisted_28
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("span", _hoisted_35, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen013.svg" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.data.data.ongoingEventsCount), 1),
                        _hoisted_37
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", _hoisted_42, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen013.svg" })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.data.data.ongoingPropertiesCount), 1),
                        _hoisted_44
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("span", _hoisted_50, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen014.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.data.data.historicalEventsCount), 1),
                      _hoisted_52
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("span", _hoisted_57, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen014.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.data.data.historicalPropertiesCount), 1),
                      _hoisted_59
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_apexchart, {
              class: "mixed-widget-6-chart card-rounded-bottom",
              options: _ctx.chartOptions,
              series: _ctx.series,
              height: _ctx.chartHeight,
              type: "area"
            }, null, 8, ["options", "series", "height"])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}